import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

// config
import { navigationConfig } from '../../config/navigation.config';

// Core
import { ErrorMessage } from '../../../core/model/error-message';
import { IBoolResult, BoolResult } from '../../../core/interfaces/bool-result';
import { UiMessageSnackService } from '../../../core/components/message-snack/service/message-snack.service';

// Redux
import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '../../../core/store/store';

// own feature
import {
   navigationStore1stDisplayOptions, navigationStore2stDisplayOptions
} from '../../store/actions';
import { NAV_DISPLAY_OPTIONS_INITIAL_STATE } from '../../model/nav-display-options.interface';
import { INavGraphDisplayOptionEdges } from '../../model/nav-display-edgegroup-pairs';
import { NavGraphVariant } from '../../model/nav.types';

@Component({
   selector: 'app-nav-graph-view-options',
   templateUrl: './nav-graph-view-options.html',
   styleUrls: ['./nav-graph-view-options.scss']
})
export class NavGraphViewOptionsComponent implements OnInit, OnChanges {

   // ctrl searchOption
   public _selectedViewOption = 0;
   public _optionsEdgeFilterPairs: { uiMessage: string, value: number }[] = [];
   public optionsEdgeGroupPairs: { uiMessage: string, value: string }[] = [];

   // form
   public _optionsForm: FormGroup = null;

   @Input() public readonly graphVariant: NavGraphVariant;
   @Input() public readonly displayOptionEdges: INavGraphDisplayOptionEdges[] = null;

   constructor(
      private _store: NgRedux<IAppState>
   ) { }

   ngOnInit() {
      // -- initialize FormGroup ------------------------------------------------------------------
      this._optionsForm = new FormGroup({
         optionsEdgeLabelCtrl: new FormControl(NAV_DISPLAY_OPTIONS_INITIAL_STATE.displayEdgeLabels),
         optionsEdgeGroupsCtrl: new FormControl('all'),
         optionsEdgeFilterCtrl: new FormControl(NAV_DISPLAY_OPTIONS_INITIAL_STATE.displayEdgeLevels)
      });

      // -- edge group - fill control -------------------------------------------------------------
      this._optionsEdgeFilterPairs.push({
         uiMessage: 'Alle Ebenen',
         value: 0
      });
      this._optionsEdgeFilterPairs.push({
         uiMessage: '1 Ebene',
         value: 1
      });
      this._optionsEdgeFilterPairs.push({
         uiMessage: '2 Ebenen',
         value: 2
      });
      this._optionsEdgeFilterPairs.push({
         uiMessage: '3 Ebenen',
         value: 3
      });

      // default value
      this.optionsEdgeGroupPairs = [];
      this.optionsEdgeGroupPairs.push({
         uiMessage: 'Alle',
         value: 'all'
      });

      // edges groups available in current graph
      if (this.displayOptionEdges) {
         this.displayOptionEdges.forEach( (item: INavGraphDisplayOptionEdges) => {
            // existInCont enthält boolean, ob EdgeGroup in aktuellem Graph vorkommen
            if (item.existInCont) {
               this.optionsEdgeGroupPairs.push({
                  uiMessage: item.uiText,
                  value: item.value
               });
            }
         });
      }

      // current selected value
      this._optionsForm.get('optionsEdgeGroupsCtrl')
         .setValue(this._store.getState().navigationState.element1stDisplayOptions.displayEdgeGroups);

      // -- edge labels ---------------------------------------------------------------------------
      this._optionsForm.get('optionsEdgeLabelCtrl')
         .setValue(this._store.getState().navigationState.element1stDisplayOptions.displayEdgeLabels);

      // -- edge labels ---------------------------------------------------------------------------
      this._optionsForm.get('optionsEdgeFilterCtrl')
         .setValue(this._store.getState().navigationState.element1stDisplayOptions.displayEdgeLevels);

      // -- value change of form ------------------------------------------------------------------
      this._optionsForm.valueChanges.subscribe(val => {
         // save to GRAPH1 or GRAPH2
         if (this.graphVariant === 'GRAPH1') {
            this._store.dispatch(navigationStore1stDisplayOptions(
               {
                  displayEdgeLevels: val.optionsEdgeFilterCtrl,
                  displayEdgeGroups: val.optionsEdgeGroupsCtrl,
                  displayEdgeLabels: val.optionsEdgeLabelCtrl
               }
            ));
         } else {
            this._store.dispatch(navigationStore2stDisplayOptions(
               {
                  displayEdgeLevels: val.optionsEdgeFilterCtrl,
                  displayEdgeGroups: val.optionsEdgeGroupsCtrl,
                  displayEdgeLabels: val.optionsEdgeLabelCtrl
               }
            ));
         }
      });
   }

   ngOnChanges() {
      // check
      if (!this._optionsForm || !this.displayOptionEdges || this.displayOptionEdges.length === 0) {
         return;
      }

      // edge group
      this.optionsEdgeGroupPairs = [];
      this.optionsEdgeGroupPairs.push({
         uiMessage: 'Alle',
         value: 'all'
      });

      this.displayOptionEdges.forEach( (item: INavGraphDisplayOptionEdges) => {
         // existInCont enthält boolean, ob EdgeGroup in aktuellem Graph vorkommen
         if (item.existInCont) {
            this.optionsEdgeGroupPairs.push({
               uiMessage: item.uiText,
               value: item.value
            });
         }
      });
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/compv/nav-graph-view-options/nav-graph-view-options.ts